import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App crashed:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-shell">
          <div className="app-container">
            <div className="panel-dark p-8 text-center mt-12">
              <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
              <p className="text-gray-400 mb-6">The page encountered an error. Please try again.</p>
              <pre className="text-sm text-red-400 mb-6 bg-zinc-950 p-4 rounded-xl border border-zinc-800 text-left overflow-auto max-h-40">
                {String(this.state.error)}
              </pre>
              <button
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.href = "/";
                }}
                className="btn-primary-dark"
                data-testid="error-go-home-btn"
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
